"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
tslib_1.__exportStar(require("./typings"), exports);
var Button_1 = require("./Button");
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return Button_1.Button; } });
//# sourceMappingURL=index.js.map